package com.eladfinish.bible.contest.screens.search.ai

import com.eladfinish.bible.contest.screens.search.ai.remote.AiSearchApi

class AiSearchRepositoryImpl(
    private val api: AiSearchApi,
) : AiSearchRepository {

    override suspend fun getAiSearchSuggestion(
        prompt: String,
    ): Result<AiSearchSuggestion> = runCatching {
        val response = api.getAiSearchSuggestion(
            prompt = prompt,
        )

        val expression = response.expression
            .trim()
            .takeIf(String::isNotEmpty)
            ?: error("AI returned an empty expression")

        AiSearchSuggestion(
            expression = expression,
            explanation = response.explanation?.trim().takeUnless { it.isNullOrEmpty() },
        )
    }
}
